import { UserRest } from "@/services/rest/user.rest";

export class RegisterService {
    constructor(private _user = new UserRest()) {}

    registerUser(data: any) {
        return this._user.registerUser(data);
    }
}